import React from "react";
import { Link, Redirect, useParams, withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  root: {
    padding: "10px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: 14,
  },
});

const ViewIssue = (props) => {
  const classes = useStyles();

  const {id} = useParams();
  const issue = props.issues.find(issue => issue.id === id);
  
  if (!props.users.isAuthenticated) {
    return <Redirect to="/issue-tracker/" />
  }

  return (
    <div className={classes.root}>
      <Link to='/issue-tracker/issues'>Back</Link>
      <h1>Issue Details</h1>
      {
        issue
        ? (
          <div>
            <Card style={{width: "80vw"}}>
              <CardContent>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                  Last Updated- <b>{issue.lastUpdated}</b> by- <b>{issue.lastUpdatedByName}</b>
                </Typography>
                <Typography gutterBottom variant="h5" component="h2">
                  {issue.description}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Severity- <b>{issue.severity}</b>
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Status- <b>{issue.status}</b>
                </Typography>
                <Typography style={{marginTop: "10px"}} variant="body2" component="p">
                  {issue.createdDate + " - " + issue.resolvedDate}
                </Typography>
                <Typography style={{marginTop: "10px"}} variant="body2" component="h2">
                  Logged By- <b>{issue.loggedByName}</b>
                </Typography>
              </CardContent>
            </Card>
            </div>
        )
        : (<b>No issue with id: {id}</b>)
      }
    </div>
  );
}

function mapStateToProps(state) {
  //console.log("[AllIssuesPage] ", state);
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewIssue));
